import DataFreshness from './DataFreshness';
import {analyticsFetch as fetch} from './analyticsPolling';
import React, { useEffect, useState } from 'react';
import AutomationScenarioPlayers from './AutomationScenarioPlayers';
import MetricValues from './MetricValues';
import AutomationScenarioProgress, { progressDate } from './AutomationScenarioProgress';

const metrics = [
  ['trigger_count', 'Trigger fired'],
  ['filter_reached_count', 'Reached Filter'],
  ['filter_passed_count', 'Passed Filter'],
  ['action_count', 'Actions completed'],
  ['send_error_count', 'Sending errors']
];

const AutomationScenarioResults = ({ scenario, onClose }) => {
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');
  const [showPlayers, setShowPlayers] = useState(false);
  useEffect(() => {
    if (showPlayers) return undefined;
    let controller;
    const refresh = async () => {
      controller?.abort();
      const current = new AbortController();
      controller = current;
      try {
        const response = await fetch(`/event-scenarios/${scenario.id}/results`, {
          headers: { Accept: 'application/json' }, signal: current.signal
        });
        if (!response.ok) throw new Error();
        const data = await response.json();
        if (!current.signal.aborted) { setResults(data); setError(''); }
      } catch (err) {
        if (err.name !== 'AbortError' && !current.signal.aborted) setError('Could not load results. Please try again.');
      }
    };
    refresh();
    const interval = setInterval(refresh, 5000);
    return () => { clearInterval(interval); controller?.abort(); };
  }, [scenario.id, showPlayers]);

  if (showPlayers) return <AutomationScenarioPlayers scenario={scenario} onBack={() => setShowPlayers(false)} onClose={onClose} />;

  return <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4'>
    <section role='dialog' aria-modal='true' aria-labelledby='scenario-results-title'
      className='bg-white rounded-xl shadow-xl w-full max-w-xl max-h-[90vh] overflow-y-auto'>
      <div className='flex justify-between items-center px-5 py-4 border-b border-slate-200'>
        <h2 id='scenario-results-title' className='font-semibold'>Scenario results</h2>
        <button type='button' aria-label='Close results' onClick={onClose}>×</button>
      </div>
      <div className='p-5 space-y-4'>
        <p className='font-medium text-slate-800 break-words'>{scenario.name}</p>
        <DataFreshness freshness={results?.freshness} updatedAt={results?.updated_at} error={error} />
      {error && <p role='alert' className='text-sm text-red-600'>{error}</p>}
        {!results && !error && <p role='status' className='text-sm text-slate-500'>Loading results…</p>}
        {results && <>
          <p className='automation-progress-note'>Updates every 5 seconds.</p>
          <AutomationScenarioProgress progress={results.progress} />
          <MetricValues metrics={results.metric_catalog} />
          <dl className='divide-y divide-slate-100'>
            {metrics.map(([key, label]) => <div key={key} className='flex justify-between gap-4 py-3'>
              <dt className='text-sm text-slate-600'>{label}</dt>
              <dd className='font-semibold text-slate-900'>{results[key].toLocaleString('en-US')}</dd>
            </div>)}
            <div className='flex justify-between gap-4 py-3'>
              <dt className='text-sm text-slate-600'>Last Trigger</dt>
              <dd className='text-sm text-slate-900'>{results.last_triggered_at ? progressDate(results.last_triggered_at) : 'No triggers yet'}</dd>
            </div>
          </dl>
          <p className='text-xs text-slate-500'>Actions count accepted messages. Email delivery and opens are not included.</p>
        </>}
        <div className='flex justify-between'><button type='button' onClick={() => setShowPlayers(true)}
          className='px-3 py-2 text-sm rounded-lg bg-slate-100 text-slate-700 hover:bg-slate-200'>Players</button><button type='button' onClick={onClose}
          className='px-3 py-2 text-sm rounded-lg bg-slate-100 text-slate-700 hover:bg-slate-200'>Close</button></div>
      </div>
    </section>
  </div>;
};

export default AutomationScenarioResults;
